import { Text, Icon, HStack, Box } from "@chakra-ui/react";
import { Cell } from "./Cell";
import { CraAttribute, CraAttributes } from "@keita/lanepatrol-sdk";
import { CraNodeCoding } from "../../../../../coding/models/CraNodeCoding";
import { getAttributeValue } from "../../../../../coding/utils/attribute-value";
import { useStores } from "../../../../../shared/stores/RootStore";
import { CheckIcon } from "../../../../../shared/views/icons";
import { firstCellWidth } from "./constants";
import { CSSProperties } from "react";
import { observer } from "mobx-react";

interface Props {
  codingEntry?: CraNodeCoding;
  index: number;
  setRowSelected: (nodeId: string, value: boolean, shiftKey: boolean) => void;
  style: CSSProperties;
  readOnly: boolean;
}
const RowBase: React.FC<Props> = ({
  index,
  codingEntry,
  setRowSelected,
  style,
  readOnly,
}) => {
  const { craNodeStore } = useStores();
  if (!codingEntry) return null;

  const nodeId = codingEntry.craNodeId;

  const isSelectedNode = craNodeStore.getSelected()?.id === nodeId;
  const selected = craNodeStore.multiSelectedIds.has(nodeId);

  return (
    <HStack
      style={{ ...style, width: "fit-content" }}
      id={`row-${nodeId}`}
      gap={0}
      _hover={{ bg: selected ? "primary.100" : "gray.50" }}
      cursor={readOnly ? "not-allowed" : "pointer"}
      opacity={readOnly ? 0.5 : 1}
      bg={selected ? "primary.50" : "transparent"}
      onClick={(event) => {
        if (readOnly) return;

        setRowSelected(nodeId, !selected, event.shiftKey);
        craNodeStore.select(nodeId);
      }}
    >
      <HStack
        alignSelf={"stretch"}
        width={`${firstCellWidth}px`}
        position="sticky"
        left={0}
        zIndex={1}
        bg={selected ? "primary.50" : "white"}
      >
        <Box minW={"36px"}>
          {selected && <Icon ml={5} color={"primary.600"} as={CheckIcon} />}
        </Box>

        <Text
          fontSize="sm"
          fontWeight="semibold"
          ml={2}
          minWidth={10}
          color={isSelectedNode ? "primary.600" : "black"}
        >
          {index + 1}
        </Text>
      </HStack>

      {CraAttributes.all.map((attribute: CraAttribute) => (
        <Cell
          key={attribute.name}
          attribute={attribute}
          value={getAttributeValue(attribute.name, codingEntry.attributes)}
          suggested={
            !!codingEntry.suggestions.find((s) => s === attribute.name)
          }
        />
      ))}
    </HStack>
  );
};

export const Row = observer(RowBase);
